<script>
import modalMixin from '@phoenix/mixins/modalMixin';
import Modal from '@maison/components/common/Modal.vue';

export default {
  components: {
    Modal,
  },

  mixins: [modalMixin],

  computed: {
    modalOptions() {
      return {
        focusOnOpen: `${this.id}-content`,
        onShow: () => {
          const content = document.querySelector(`#${this.id}-content`);
          Toolkit.modalScrollable(content, {
            horizontalOnly: true,
            progressbar: true,
          });
        },
      };
    },

    modalClasses() {
      return ['modal-scrollable--ww25'];
    },
  },
  mounted() {
    new Toolkit.Ww25ModalController(this.$refs.scrollableModalWw25.$el);
    new Toolkit.AnimateGroupReveal({
      parentSelector: `#${this.id}`,
      childrenSelector: '.modal-scrollable__slide',
      start: window.innerWidth > 768 ? 'top 70%' : 'top 95%',
      delay: 0,
      animateByRow: false,
      useObserver: true,
      observerOptions: {
        threshold: 0.3,
      },
    });
  },
};
</script>

<template>
  <modal
    :id="id"
    ref="scrollableModalWw25"
    :classes="modalClasses"
    :fullscreen="true"
    :naked="true"
    :options="modalOptions"
    :should-display-header="false"
    :should-wrap-content="false"
    :scrollable="true"
    :scrollable-horizontal-only="true"
    :theme-dark="true"
  >
    <template #header>
      <slot name="header" />
    </template>

    <template #content>
      <slot name="content" />
    </template>
  </modal>
</template>
